<template>
  <div class="SuccessTrade success-trade">
    <div class="success-container">
      <img src="/img/success.png" alt="">
      <h2>Special trade successfully created!</h2>
      <div class="button-holder">
        <button class="btn" @click="backToList()">Back to the list</button>
        <button class="btn" @click="viewTrade()">View trade</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "SuccessTrade",
  computed: {
    currentProgram: {
      get() {
        return this.$store.state.currentProgram;
      },
      set(value) {
        this.$store.commit('setter', {currentProgram: value})
      }
    },
    isNewTrade: {
      get() {
        return this.$store.state.isNewTrade;
      },
      set(value) {
        this.$store.commit('setter', {isNewTrade: value})
      }
    },
    isEditTrade: {
      get() {
        return this.$store.state.isEditTrade;
      },
      set(value) {
        this.$store.commit('setter', {isEditTrade: value})
      }
    },
  },
  mounted() {
    document.querySelector('.back').style.display = 'none'
  },
  methods: {
    backToList() {
      this.isEditTrade = false;
      this.isNewTrade = false;
      this.$store.dispatch('getPrograms', {
        action: 'list',
        limit: 10,
        offset: 0,
        login: this.Lead.info.login
      });
    },
    viewTrade() {
      this.isNewTrade = false;
      this.isEditTrade = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.SuccessTrade {
  .button-holder {
    display: flex;
    justify-content: center;

    .btn {
      &:first-child {
        margin-right: 40px;
      }
    }
  }

  h2 {
    color: #320d57;
    font-size: 23px;
    margin-bottom: 46px;
    font-weight: 400;
  }

  .success-container {
    text-align: center;

    img {
      display: inline-block;
      margin-bottom: 25px;
    }
  }
}
</style>
